module.exports = __webpack_public_path__ + "media/images/countryrect/ke-c67dfd32fa7f7fa2f6f68a0cf83be59e.svg";